<template>
  <general-layout>
    <b-container>
      <b-row>
        <b-col>
          <h2>Machine Tokens</h2>
          <div class="mb-5 p-4 border rounded border-kitty-grey-medium">{{ generatedToken }}</div>
          <b-button block type="button" variant="primary" @click="generateNewToken">Generate</b-button>
        </b-col>
      </b-row>
    </b-container>
  </general-layout>
</template>

<script>
import { mapState } from 'vuex'
import GeneralLayout from '@/components/GeneralLayout.vue'
import store from '@/store'

export default {
  name: 'MachineTokens',
  components: {
    GeneralLayout
  },
  computed: {
    ...mapState('currentUser/tokens', ['generatedToken'])
  },
  methods: {
    async generateNewToken (e) {
      e.preventDefault()
      await store.dispatch('currentUser/tokens/generateNewToken')
    }
  }
}
</script>
